export const theme = {
    primaryColor: '#11C84F',
    lightPrimary: '#82FFAD',
    scoundry: '#ff0266',
    white: '#ffffff',
    light: '#F6F6F6',
    black: '#000',
    dark: '#656565',
    gray: '#818894',
    whiteSecondary: '#f8f8f8',
    whiteSmoke: '#fafafa',
    hoverOnWhite: '#f0f0f0',
    badgeColor: '#FF2442',
    orangeCircle: '#FFAA00',
    orange: '#FFB467',
    blue: '#00BEDD',
    danger: '#dc3545',
    purple: '#B369A7',
    carnation: '#FF7070',
    trash: '#920F00',
    chatYou: '#65D753',
    chatOther: '#818894',
    borderGray: '#E9E9E9'
};
